import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable()
export class NavigatorService {
  constructor(private router: Router) {}

  toLogin() {
    this.router.navigate(["/pages/login"]);
  }

  toDashboard() {
    this.router.navigate(["/dashboard"]);
  }

  toTasks() {
    this.router.navigate(["/tasks"]);
  }

  toStockProducts() {
    this.router.navigate(["/stock-products"]);
  }

  toInvoices() {
    this.router.navigate(["/invoices"]);
  }

  toSettings() {
    this.router.navigate(["/pages/account-settings"]);
  }

  toProfile() {
    this.router.navigate(["/pages/profile"]);
  }
}
